import { SlidersHorizontal } from 'lucide-react';
import { Badge, Button, Tooltip } from '@heroui/react';

interface PageFilterButtonProps {
  activeFilterCount: number;
  onPress?: () => void;
  /** Alvo do tutorial guiado; o botão é reaproveitado em várias telas. */
  tourId?: string;
}

export function PageFilterButton({ activeFilterCount, onPress, tourId }: PageFilterButtonProps) {
  const hasActiveFilters = activeFilterCount > 0;
  const badgeLabel = activeFilterCount > 99 ? '99+' : String(activeFilterCount);
  const tooltipLabel = hasActiveFilters
    ? `${activeFilterCount} filtro${activeFilterCount === 1 ? '' : 's'} aplicado${activeFilterCount === 1 ? '' : 's'}`
    : 'Filtrar busca';

  return (
    <Tooltip delay={400}>
      <Tooltip.Trigger>
        <Badge.Anchor>
          <Button
            isIconOnly
            variant="secondary"
            aria-label={tooltipLabel}
            onPress={onPress}
            data-tour={tourId}
          >
            <SlidersHorizontal size={18} />
          </Button>
          {hasActiveFilters ? (
            <Badge
              size="sm"
              variant="primary"
              color="danger"
              placement="top-right"
              aria-label={tooltipLabel}
              className="min-h-5 min-w-5 px-1 text-[10px] font-bold leading-none shadow-md"
            >
              {badgeLabel}
            </Badge>
          ) : null}
        </Badge.Anchor>
      </Tooltip.Trigger>
      <Tooltip.Content placement="bottom">{tooltipLabel}</Tooltip.Content>
    </Tooltip>
  );
}
